import { PerAdultLabel } from '@/src/components/common/srp/perAdultLabel'
import useFormatCurrencyForSrp from '@/src/hooks/currency/useFormatCurrencyForSrp'
import { Box, Button, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
type FlightDetailsFooterProps = {
    price?: number | null
    onSelect: () => void
    strikeOffPrice?: number | null
    showSelectButton: boolean
    buttonCTA: string
    isBookingInProgress?: boolean
    isButtonDisabled?: boolean
}

function FlightDetailsFooter ({
    price,
    onSelect,
    strikeOffPrice,
    showSelectButton,
    buttonCTA,
    isBookingInProgress,
    isButtonDisabled
}: FlightDetailsFooterProps) {
    // const hasPrice = !!price
    const t = useTranslations('common')
    const { formatCurrency } = useFormatCurrencyForSrp()
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            sx={{ padding: '10px', borderTop: '1px solid', borderColor: 'grey.200', }}
        >
            <Box textAlign={'start'}>
                {strikeOffPrice && (
                    <Typography
                        variant="body1"
                        fontWeight="500"
                        sx={{ textDecoration: 'line-through', color: 'grey.500' }}
                    >
                        {formatCurrency(strikeOffPrice)}
                    </Typography>
                )}

                <Typography variant="h6" fontWeight="bold">
                    {formatCurrency(price || 0)} <PerAdultLabel />
                </Typography>
            </Box>

            {showSelectButton && (
                <Button
                    variant="customVariantPrimary"
                    onClick={onSelect}
                    disabled={isBookingInProgress || isButtonDisabled}
                    sx={theme => ({
                        borderRadius: '0.5rem',
                        px: 5,
                        py: 1.2,
                        boxShadow: 'none',
                        // ...(isBookingInProgress && !isButtonDisabled && {
                        //     bgcolor: '#FFD700 !important', // Force gold color with !important
                        //     color: '#2A5298 !important',
                        //     animation: 'pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite',
                        //     '@keyframes pulse': {
                        //         '0%, 100%': { opacity: 1 },
                        //         '50%': { opacity: 0.8 }
                        //     }
                        // }),
                        // '&:hover': {
                        //     backgroundColor: theme.palette.secondary.main,
                        //     color: theme.palette.primary.main,
                        //     boxShadow: 'none'
                        // }
                    })}
                >
                    {isBookingInProgress && !isButtonDisabled ? t('Loading') : buttonCTA}
                </Button>
            )}
        </Box>
    )
}

export default FlightDetailsFooter
